



























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import axios, { AxiosRequestConfig, AxiosPromise, AxiosResponse } from 'axios';
import { Guid } from 'guid-typescript';

@Component
export default class HelloWorld extends Vue {
  @Prop() private msg: string = 'msg';
  @Prop() private ljson: string = 'json';
  @Prop() private isStrgrModalActive = false;
  @Prop() private isAstgrModalActive = false;
  @Prop() private isLoading = false;
  @Prop() private luidRaw: string = Guid.raw();
  @Prop() private luid: string = this.luidRaw.split('-').join('');
  @Prop() private lurl: string = 'https://www.appfuhr.de/pdf/tmp/' + this.luid + '.pdf';
  @Prop() private ppjahr = 24;
  @Prop() private pport = null;
  @Prop() private ppstr = null;
  @Prop() private ppkomp = false;
  @Prop() private ppvier = false;
  @Prop() private ppsw = false;
  @Prop() private ppcstrgr = 0;
  @Prop() private ppcastgr = 0;
  @Prop() private ppstrgr = null;
  @Prop() private ppastgr = null;
  @Prop() private ppshowcal = false;
  @Prop() private lort!: Array<{ id: number, bez: string }>;
  @Prop() private lstr!: Array<{ id: number, bez: string, cstrgr: number, castgr: number }>;
  @Prop() private lstrgr!: Array<{ id: number, grenze: string }>;
  @Prop() private lastgr!: Array<{ id: number, grenze: string }>;

  private mounted() {
    axios.get('https://www.appfuhr.de/api/json.php?tbl=ort')
      .then((res: AxiosResponse) => {
        this.ljson = String(res.status);
        this.lort = Array.from(res.data);
      })
      .catch((ex: any) => {
        // console.log(ex);
      });
  }

  makepdf() {
    this.isStrgrModalActive = false;
    this.isAstgrModalActive = false;

    if (this.ppcstrgr > 1 && this.ppstrgr == null) {
      this.isStrgrModalActive = true;
      return;
    }

    if (this.ppcastgr > 1 && this.ppastgr == null) {
      this.isAstgrModalActive = true;
      return;
    }

    this.isLoading = true;

    axios.get('https://www.appfuhr.de/api/makekal.php?uid='+this.luid+'&str=' + this.ppstr + '&strgr=' + this.ppstrgr + '&astgr=' + this.ppastgr + '&komp=' + this.ppkomp + '&vier=' + this.ppvier + '&jahr=' + this.ppjahr + '&max=999')
      .then((res: AxiosResponse) => {
        this.ljson = String(res.status);

        axios.get('https://www.appfuhr.de/pdf/makepdf.php?uuid=' + this.luid + '&str=' + this.ppstr + '&jahr=' + this.ppjahr + '&sw=' + this.ppsw)
          .then((res: AxiosResponse) => {
            this.ljson = String(res.status);
            this.ppshowcal = true;
            this.isLoading = false;
          })
          .catch((ex: any) => {
            // console.log(ex);
          }
        );
      })
      .catch((ex: any) => {
        // console.log(ex);
      }
    );
  }

  private seljahr() {
    this.ppstr = null;
    this.ppstrgr = null;
    this.ppastgr = null;
    this.ppshowcal = false;
  }

  private selort() {
    // console.log('pport',this.pport);

    axios.get('https://www.appfuhr.de/api/json.php?tbl=str&ort=' + this.pport)
      .then((res: AxiosResponse) => {
        this.lstr = Array.from(res.data);
      })
      .catch((ex: any) => {
        // console.log(ex);
      });

      this.ppstr = null;
      this.ppstrgr = null;
      this.ppastgr = null;
      this.ppshowcal = false;
  }

  private selstr() {
    // console.log('ppstr', this.ppstr);
    this.ppcstrgr = this.lstr.filter(ll => ll.id == this.ppstr)[0].cstrgr;
    this.ppcastgr = this.lstr.filter(ll => ll.id == this.ppstr)[0].castgr;

    axios.get('https://www.appfuhr.de/api/json.php?tbl=strgr&str=' + this.ppstr)
      .then((res: AxiosResponse) => {
        this.lstrgr = Array.from(res.data);
      })
      .catch((ex: any) => {
        // console.log(ex);
      });

    axios.get('https://www.appfuhr.de/api/json.php?tbl=astgr&str=' + this.ppstr)
      .then((res: AxiosResponse) => {
        this.lastgr = Array.from(res.data);
      })
      .catch((ex: any) => {
        // console.log(ex);
      });

    this.ppstrgr = null;
    this.ppastgr = null;
    this.ppshowcal = false;
  }

  private reset_show() {
    this.ppshowcal = false;
  }

  private reset() {
    this.pport = null;
    this.ppstr = null;
    this.ppstrgr = null;
    this.ppastgr = null;
    this.ppkomp = false;
    this.ppvier = false;
    this.ppshowcal = false;
  }
}
